import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { kioskApi } from '../lib/kiosk-api.js';

export function KioskDocDetail({ session, id, onBack }) {
  const locKey = session.location.key;
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    kioskApi('GET', `/api/kiosk/${locKey}/knowledge-docs/${id}`, null, session.token)
      .then(r => setDoc(r.doc))
      .catch(e => setErr(e.message || String(e)));
  }, [id]);
  if (err) return <div style={{ background: '#fee', padding: 12, borderRadius: 8, color: '#b91c1c', fontSize: 13 }}>{err}</div>;
  if (!doc) return <div style={{ fontSize: 13, color: '#9e9e9e' }}>Loading…</div>;
  return (
    <div>
      <button onClick={onBack} style={{ background: 'transparent', border: 'none', color: 'var(--forest)', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '4px 0 12px', fontFamily: 'inherit' }}>
        ← Back to policies
      </button>
      <div className="card">
        <div style={{ fontSize: 11, color: '#9e9e9e', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
          {doc.category}{doc.type ? ` · ${doc.type}` : ''}
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#212121', marginTop: 4 }}>{doc.title}</div>
        {doc.content && (
          <div style={{ fontSize: 14, color: '#212121', lineHeight: 1.65, whiteSpace: 'pre-line', marginTop: 14 }}>{doc.content}</div>
        )}
        {doc.attachment_filename && (
          <div style={{ marginTop: 14, fontSize: 12, color: '#757575' }}>📎 {doc.attachment_filename}</div>
        )}
      </div>
    </div>
  );
}
